import { createContext } from 'react';

// Provides the sidebar open/closed boolean to any descendant.
// Default true so NavList doesn't collapse on first render.
const SidebarOpenContext = createContext(true);

export default SidebarOpenContext;
